import { useEffect } from 'react';


const QQConnectCallback = () => {
  useEffect(() => {
    window.QC.Login.getMe((openId: string) =>  {
      if (openId) {
        window.close();
      }
    });
  });

  return null;
};

export default QQConnectCallback;
